export class PlaybackError extends Error {
    constructor(readonly errorCode: string, readonly vsid: string, message?: string) {
        super(message ?? errorCode);
    }
}
